var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSelectBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.764,
    height: 9.795
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3468",
    d: "M.707.707l7.674 7.674L16.057.707",
    fill: "none",
    stroke: "#282828",
    strokeWidth: 2
  })));
}

export default __webpack_public_path__ + "c26b2a73c00e8bddc9b2f6c43477f497.svg";
export { SvgSelectBlack as ReactComponent };